/** 1-based marker number for a POI at its index among visible POIs in array order. */
export function numericPoiMarkerNumber(pois, poiIndex) {
  let number = 0;
  for (let i = 0; i <= poiIndex; i++) {
    if (!pois[i]?.hidden) number++;
  }
  return number;
}
